'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

export function ReferralTracker() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref') || searchParams.get('r');
    if (ref) {
      // Store referral code in cookie (30 day attribution)
      const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `printen_ref=${encodeURIComponent(ref)}; expires=${expires}; path=/; SameSite=Lax`;
      // Also store in localStorage for checkout attribution
      try { localStorage.setItem('printen_ref', ref); } catch {}
      // Track the click server-side (fire and forget)
      fetch('/api/referrals/click', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code: ref, path: window.location.pathname }) }).catch(() => {});
    }
  }, [searchParams]);

  return null;
}
